import { Instagram, Youtube, Facebook, Linkedin, Music2, Play, FileText, Loader2 } from "lucide-react";
import { STATUS, PLATFORMS, fileUrl, posterUrl, playUrl } from "@/lib/api";

const ICONS = { instagram: Instagram, youtube: Youtube, facebook: Facebook, linkedin: Linkedin, tiktok: Music2 };

export const StatusBadge = ({ status }) => (
  <span className={`inline-flex items-center text-[11px] px-2 py-0.5 rounded-full border ${STATUS[status]?.cls}`} data-testid="post-status-badge">
    {STATUS[status]?.label || status}
  </span>
);

export const PlatformIcon = ({ p, className = "h-3.5 w-3.5" }) => {
  const Icon = ICONS[p] || Music2;
  return <Icon className={className} style={{ color: PLATFORMS[p]?.color }} />;
};

export const PlatformRow = ({ platforms = [] }) => (
  <span className="inline-flex gap-1.5">{platforms.map((p) => <PlatformIcon key={p} p={p} />)}</span>
);

export const MediaThumb = ({ file, className = "" }) => (
  <div className={`relative bg-black/40 overflow-hidden ${className}`}>
    {file.kind === "text" ? (
      <div className="h-full w-full grid place-items-center bg-slate-800/60 text-slate-300"><div className="text-center"><FileText className="h-8 w-8 mx-auto mb-1 text-sky-300" /><span className="text-[10px] font-mono uppercase">TXT</span></div></div>
    ) : file.kind === "video" ? (
      <>
        <ThumbImg file={file} className="h-full w-full object-cover" />
        {(file.has_poster || file.variants_failed) && <div className="absolute inset-0 grid place-items-center"><div className="h-9 w-9 rounded-full bg-black/60 grid place-items-center"><Play className="h-4 w-4 text-white" /></div></div>}
      </>
    ) : (
      <ThumbImg file={file} className="h-full w-full object-cover" />
    )}
  </div>
);

export const ThumbImg = ({ file, className = "" }) => {
  if (file.has_poster) return <img src={posterUrl(file)} alt={file.name || ""} loading="lazy" className={className} data-testid="media-poster" />;
  if (file.kind === "video" && file.variants_failed) return <video src={fileUrl(file.id)} preload="metadata" muted className={className} />;
  if (file.kind === "video") return <div className={`grid place-items-center bg-black/60 ${className}`} data-testid="media-poster-pending"><div className="text-center"><Loader2 className="h-6 w-6 animate-spin text-teal-300 mx-auto mb-1" /><span className="text-[10px] text-slate-300">Vorschau wird erstellt</span></div></div>;
  return <img src={fileUrl(file.id)} alt={file.name || ""} loading="lazy" className={className} />;
};

export const VideoPlayer = ({ file, className = "", autoPlay = false }) => (
  <video src={playUrl(file)} poster={posterUrl(file)} controls playsInline autoPlay={autoPlay} preload="metadata" className={className} data-testid="video-player" />
);
